import styled from 'styled-components'
import { Typography } from '@elevate_security/elevate-component-library'

const { Body } = Typography

export const HelperContent = styled.div`
  padding: 24px 24px;
  border-radius: 6px;
  background-color: #f5f6f8;
  margin-bottom: 24px;
  h2 {
    padding: 5px 0;
  }
`

export const HelpText = styled(Body).attrs({
  fontWeight: 'normal',
  color: '700'
})`
  line-height: 24px;
`

export const Link = styled.a`
  color: rgb(12, 125, 132);
  text-decoration: none;
  justify-content: center;
  cursor: pointer;
  &:hover {
    color: rgb(3, 155, 161);
    text-decoration: underline;
  }
`

export const Flex = styled.div`
  display: flex;
  justify-content: space-between;
  > div {
    margin: 0;
  }
  > a {
    margin: auto;
  }
  margin-bottom: 24px;

  /* force dropdown to open towards bottom */
  [class^='CustomSelectstyles__CustomSelectContainer'].to-top {
    .dropdown-container {
      transform: none;
    }
  }
`

export const Label = styled(Body).attrs({
  fontWeight: 'bold',
  color: '700'
})`
  margin-bottom: 8px;
`

export const SelectBehavior = styled.div`
  margin-bottom: 12px;
  > [class^='RadioButtonstyles__RadioButtonWrapper'] {
    flex-wrap: wrap;
    > div {
      flex: 1;
      min-width: 230px;
      max-width: 230px;
      > label {
        padding-right: 0;
        margin-right: 25px;
      }
    }
  }
`
export const SelectConnectorType = styled.div`
  > [class^='RadioButtonstyles__RadioButtonWrapper'] {
    margin-top: 16px;
    > div {
      min-width: 300px;
      max-width: 300px;
      border: 1px solid #dde1e7;
      padding: 16px;
      margin: 0px 16px;
      border-radius: 4px;
      > label {
        display: inline;
      }
    }
  }
`
export const AlternateFieldWrapper = styled.div`
  [class^='inputstyles__InputContainer'] {
    width: 100%;
    justify-content: flex-start;
    margin-bottom: 20px;
    input {
      width: 45%;
    }
  }
`
